import SEO from "../../../components/seo.jsx"
import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import HeroImg   from "../../../assets/dr-idris-MD.jpeg";
import DrIdris from "../../../assets/team/Dr-idris.jpeg";

gsap.registerPlugin(ScrollTrigger);
const cinzel = { fontFamily: "'Cinzel', serif" };
const PAGE = {
  hero: {
    eyebrow: "Hair Transplant",
    heading: "Hair Transplant Surgery in Bangalore",
    sub: "Advanced FUE, FUT & DHI techniques led by Dr. Idris natural, lasting results at Clinique Internationale.",
  },

  breadcrumb: [
    { label: "Home", href: "/" },
    { label: "Bangalore", href: "/" },
    { label: "Hair Transplant Surgery in Bangalore", href: null },
  ],

  /* ── SECTION 1 Bio / Intro ── */
  bio: {
    eyebrow: "Lead Surgeon",
    heading: "Hair Transplant Surgery in Bangalore Led by Dr. Idris",
    paragraphs: [
      "Meet Dr. Idris, a facial cosmetic and hair transplant surgeon with a global reputation for excellence, and the Director of Clinique Internationale's Bangalore Division. He is renowned for his expertise in precision-based hair transplant procedures.",
      "As the Director of Clinique Internationale in Bangalore, Dr. Idris plays a crucial role in providing top-notch services with an exclusive focus on Hair Transplant Surgery. He also serves as a Consultant Surgeon at GM-Apollo Hospital and the 32 Smiles chain in Bangalore.",
      "He has successfully performed hair transplant surgery for thousands of patients, including hundreds of dentists and doctors from around the world, carrying out each procedure himself with a deeply patient-centred philosophy. With a diverse clientele, Dr. Idris is sought after for his exceptional surgical skills.",
      "Are you in search of a top-notch hair transplant specialist in Bangalore? Look no further than Dr. Idris, a premier choice in the field. With a stellar reputation and a proven track record of delivering exceptional results, Dr. Idris is highly regarded for his expertise in hair restoration.",
      "He stays at the forefront of industry advancements and prioritizes patient satisfaction, making him a standout figure in the field. Experience a seamless and successful hair transplant surgery journey with Dr. Idris's comprehensive approach and compassionate care.",
    ],
    tags: ["AOMSI MEMBER", "PACE Certified", "GM-Apollo Hospital", "Director, Clinique Internationale Bangalore"],
  },

  /* ── SECTION 2 Cost ── */
  costSection: {
    eyebrow: "Pricing",
    heading: "Hair Transplant Surgery Cost in Bangalore",
    paragraphs: [
      "Clinique Internationale is your top choice for an affordable hair transplant surgery in Bangalore, offering the best hair transplant cost in the city. On average, hair transplant surgery price in Bangalore can range from ₹70,000 to ₹5,00,000 ($850 to $7000 USD).",
      "With a commitment to excellence, our skilled professionals ensure a seamless and cost-effective hair transplant experience. When it comes to hair transplantation, Follicular Unit Transplantation (FUT) is generally associated with a higher price tag than Follicular Unit Extraction (FUE).",
    ],
    perGraft: [
      { label: "DHI Hair Transplant", range: "₹45 – ₹220 per graft" },
      { label: "FUE Hair Transplant", range: "₹30 – ₹190 per graft" },
      { label: "FUT Hair Transplant", range: "₹35 – ₹210 per graft" },
    ],
    tableHeads: ["Stage of Baldness", "Grafts Required", "Estimated Cost"],
    tableRows: [
      { stage: "Stage 1", grafts: "800 – 1000",   cost: "₹25,000 – ₹35,000"    },
      { stage: "Stage 2", grafts: "1500 – 2000",  cost: "₹40,000 – ₹60,000"    },
      { stage: "Stage 3", grafts: "1700 – 2500",  cost: "₹50,000 – ₹70,000"    },
      { stage: "Stage 4", grafts: "2300 – 2800",  cost: "₹70,000 – ₹85,000"    },
      { stage: "Stage 5", grafts: "2500 – 2900",  cost: "₹85,000 – ₹95,000"    },
      { stage: "Stage 6", grafts: "2700 – 3000",  cost: "₹1,00,000 – ₹1,40,000"  },
      { stage: "Stage 7", grafts: "3000 – 3500",  cost: "₹1,45,000 – ₹3,20,000" },
    ],
    note: "Trust Clinique Internationale's Bangalore centre for transformative solutions that won't break the bank, making high-quality hair restoration surgery accessible to all.",
  },

  /* ── SECTION 3 Procedure Steps ── */
  steps: [
    { num: "01", title: "Consultation and Assessment", desc: "Patients undergo a thorough consultation with our qualified hair transplant specialist assessing current hair loss, potential donor areas, and expectations." },
    { num: "02", title: "Preparation and Anesthesia", desc: "The patient's hair in the donor area is trimmed to a suitable length. Local anaesthesia is administered to both donor and recipient areas for comfort." },
    { num: "03", title: "Extraction of Hair Follicles", desc: "Follicles are extracted using FUE (individually, via a specialised punch tool) or FUT (a donor-area strip dissected into individual grafts)." },
    { num: "04", title: "Recipient Site Creation & Implantation", desc: "Follicles are carefully implanted into recipient sites, matching the natural direction and angle of hair growth for a natural-looking result." },
    { num: "05", title: "Postoperative Care and Recovery", desc: "Patients receive instructions on washing the hair, avoiding certain activities, and taking prescribed medications for optimal healing." },
  ],

  /* ── SECTION 4 Stages of Baldness ── */
  stages: [
    { stage: "Stage 1", label: "Minimal Receding Hairline", desc: "A slight recession of the hairline, usually around the temples. More noticeable when comparing older photos." },
    { stage: "Stage 2", label: "Deepening Receding Hairline", desc: "Further recession with a more visible V-shaped pattern on the forehead. Hair loss becomes more apparent." },
    { stage: "Stage 3", label: "Widening Balding Area", desc: "Significant hair loss begins on the crown. The front and top hair areas become visibly separated." },
    { stage: "Stage 4", label: "Larger Balding Areas", desc: "Hair loss becomes more extensive, with only a thin band separating the receding hairline from the crown." },
    { stage: "Stage 5", label: "Balding at the Crown", desc: "Further enlargement of crown balding, and the band of hair between front and crown areas thins further." },
    { stage: "Stage 6", label: "Extensive Balding", desc: "Severe hair loss on crown and front. Only a horseshoe-shaped band of hair remains on the sides and back." },
    { stage: "Stage 7", label: "Complete Baldness", desc: "Complete baldness with only a horseshoe-shaped band of hair remaining on the sides and back of the head." },
  ],

  /* ── SECTION 5 Why Clinique ── */
  whyClinique: {
    intro: "Step into the world of Clinique Internationale, where the fusion of excellence and innovation in hair transplantation awaits. Headed locally by Dr. Idris, Director of the Bangalore Division, Clinique Internationale is renowned for its unmatched standards of quality and precision. With branches across Mumbai, Pune, Bangalore and Shirdi, Clinique Internationale brings world-class expertise to individuals seeking effective solutions for hair loss.",
    reasons: [
      { num: "01", title: "Visionary Leadership", desc: "At the helm of the Bangalore centre is Dr. Idris. His pioneering approach and extensive experience treating patients from around the world set the clinic apart." },
      { num: "02", title: "State-of-the-Art Technology", desc: "The clinic's commitment to advanced tools and equipment ensures patients receive the most effective treatments available." },
      { num: "03", title: "Personalized Patient Care", desc: "Experts provide personalized consultation and treatment plans, tailoring solutions to individual requirements for optimal results." },
      { num: "04", title: "Proven Success Stories", desc: "A multitude of success stories and real testimonials showcase the clinic's expertise and effectiveness of its procedures." },
      { num: "05", title: "Ethical Practices and Transparency", desc: "The clinic upholds the highest standards of ethics and transparency, keeping patients well-informed throughout the process." },
    ],
  },

  /* ── SECTION 6 Types of Hair Transplant Surgery ── */
  types: [
    {
      num: "01",
      title: "Follicular Unit Extraction (FUE)",
      href: "/follicular-unit-extraction",
      desc: "A minimally invasive approach that extracts individual hair follicles directly from the donor area. Leaves tiny, circular scars that are far less noticeable than a linear FUT scar. Involves a more extended extraction process but often results in quicker healing.",
    },
    {
      num: "02",
      title: "Follicular Unit Transplantation (FUT)",
      href: "/follicular-unit-transplantation",
      desc: "Involves surgically removing a strip of tissue containing hair follicles from the donor area, which is then dissected into individual grafts under microscopic guidance before being implanted into the recipient area.",
    },
    {
      num: "03",
      title: "Direct Hair Implantation (DHI)",
      href: null,
      desc: "A variation of FUE where follicles are extracted and implanted simultaneously, using a specialised pen-like device (Choi pen). Offers a potentially faster procedure with minimal handling of grafts, reducing the risk of damage.",
    },
  ],

  /* ── SECTION 7 Treatments Offered ── */
  treatments: [
    { num: "01", title: "Male Hair Transplant", href: "/male-hair-transplant", desc: "Customized solutions for male-pattern baldness and hair loss, using advanced FUE or FUT techniques to restore a natural-looking hairline." },
    { num: "02", title: "Female Hair Transplant", href: "/female-hair-transplant", desc: "Specialised treatments addressing female hair loss patterns tailored solutions to restore volume and thickness in a natural, feminine way." },
    { num: "03", title: "Beard Hair Transplant", href: "/beard-hair-transplant", desc: "Precision transplanting of facial hair for beard enhancement or reconstruction, ensuring a well-defined, aesthetically pleasing appearance." },
    { num: "04", title: "Eyebrow Hair Transplant", href: "/eyebrow-hair-transplant", desc: "Artistic, meticulous restoration of eyebrow hair enhancing shape, density, and symmetry for a harmonious facial appearance." },
    { num: "05", title: "Eyelash Hair Transplant", href: "/eyelash-hair-transplant", desc: "Delicate procedures to enhance eyelash length and density, providing a fuller and more expressive look to the eyes." },
    { num: "06", title: "Advanced Techniques", href: null, desc: "FUE, FUT, DHI, and Sapphire FUE all minimally invasive, all delivering excellent, natural-looking results in Bangalore." },
  ],

  /* ── FAQs ── */
  faqs: [
    {
      q: "How much will hair transplant surgery cost in Bangalore?",
      a: "Hair transplant surgery costs in Bangalore vary based on factors like clinic reputation, location, and the number of grafts needed. On average, prices range from ₹70,000 to ₹3,00,000. It's essential to consult with clinics for accurate quotes based on individual requirements.",
    },
    {
      q: "Which age is best for hair transplant surgery?",
      a: "The ideal age is typically the late 20s to 50s. Candidates should have stabilised hair loss and a well-defined pattern. Younger individuals may not have a predictable pattern, while older candidates might have limited donor hair. A consultation helps determine suitability.",
    },
    {
      q: "Does transplanted hair fall out again?",
      a: "Transplanted hair generally doesn't fall out permanently the follicles are usually resistant to the hormone that causes hair loss. Some shedding can occur initially before new growth. Proper post-surgery care influences long-term results.",
    },
    {
      q: "Which is the best hair transplant surgery clinic in Bangalore?",
      a: "Clinique Internationale's Bangalore Division, led by Dr. Idris, is renowned for its advanced hair transplant surgery techniques and experienced specialists, and is often considered among the top clinics for delivering excellent, personalised results.",
    },
    {
      q: "How much does 3000 grafts cost in Bangalore?",
      a: "The cost of 3000 hair grafts for surgery in Bangalore varies, but generally ranges from $2,000 to $4,200, depending on the clinic and the surgeon's expertise.",
    },
  ],

  cta: {
    eyebrow: "Take the First Step",
    heading: "Begin Your Hair Restoration Journey",
    sub: "Book a personalised consultation with Dr. Idris at our Bangalore Division and get an accurate graft count, cost estimate and treatment plan all in one visit.",
    primary:   { label: "Book Consultation", href: "/contact" },
    secondary: { label: "View All Treatments", href: "/treatments" },
  },
};

/* ============================================================
   REUSABLE SUB-COMPONENTS
============================================================ */
function Eyebrow({ children, light = false }) {
  return (
    <p style={cinzel} className={`text-[10.5px] tracking-[0.28em] uppercase mb-3 flex items-center justify-center gap-2.5 ${light ? "text-[#c9a84c]/70" : "text-[#a07828]"}`}>
      <span className={`w-6 h-px ${light ? "bg-[#c9a84c]/50" : "bg-[#c9a84c]"}`} />
      {children}
    </p>
  );
}
function EyebrowLeft({ children }) {
  return (
    <p style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase text-[#a07828] mb-3 flex items-center gap-2.5">
      <span className="w-6 h-px bg-[#c9a84c]" />{children}
    </p>
  );
}
function SectionHeading({ children, light = false, left = false }) {
  return (
    <h2 style={cinzel} className={`font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.85rem] uppercase tracking-[0.05em] mb-8 leading-tight ${light ? "text-white" : "text-[#1a0f02]"} ${left ? "text-left" : "text-center"}`}>
      {children}
    </h2>
  );
}
function GoldDivider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent" />;
}
function Card({ children, className = "" }) {
  return (
    <div className={`bg-white border border-[#c9a84c]/18 rounded-2xl relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300 ${className}`}>
      <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
      {children}
    </div>
  );
}
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border rounded-xl overflow-hidden transition-colors duration-300 ${open ? "border-[#c9a84c]/40 bg-[#c9a84c]/[0.04]" : "border-[#c9a84c]/15 bg-white"}`}>
      <button className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-5 text-left" onClick={() => setOpen(p => !p)}>
        <span style={cinzel} className="text-[13px] font-bold tracking-[0.04em] text-[#1a0f02]">{q}</span>
        <span className={`flex-shrink-0 w-7 h-7 rounded-full border border-[#c9a84c]/35 flex items-center justify-center transition-transform duration-300 ${open ? "rotate-45 bg-[#c9a84c] border-[#c9a84c]" : ""}`}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 2v8M2 6h8" stroke={open ? "#1a0f02" : "#c9a84c"} strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </span>
      </button>
      {open && <div className="px-5 sm:px-6 pb-5"><p className="text-[13.5px] leading-[1.8] text-[#6b5535]">{a}</p></div>}
    </div>
  );
}

/* ============================================================
   PAGE COMPONENT
============================================================ */
export default function HairTransplantSurgeryBangalore() {
  const pageRef    = useRef(null);
  const heroEyeRef = useRef(null);
  const heroHdRef  = useRef(null);
  const heroSubRef = useRef(null);
  const secRefs    = useRef([]);
  const addRef     = (el) => el && !secRefs.current.includes(el) && secRefs.current.push(el);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";
      gsap.fromTo(heroEyeRef.current, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7, ease });
      gsap.fromTo(heroHdRef.current,  { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.75, ease, delay: 0.1 });
      gsap.fromTo(heroSubRef.current, { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.7, ease, delay: 0.18 });
      secRefs.current.forEach(el => {
        if (!el) return;
        gsap.fromTo(el, { opacity: 0, y: 36 }, {
          opacity: 1, y: 0, duration: 0.75, ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" },
        });
      });
    }, pageRef);
    return () => ctx.revert();
  }, []);

  const wrap = "max-w-6xl mx-auto px-5 sm:px-8 lg:px-12";
  const sec  = "py-16 sm:py-20 md:py-24";

  return (
    <>
    <SEO
  title="Hair Transplant Surgery in Bangalore | Dr. Idris"
  description="Advanced hair transplant surgery in Bangalore at Clinique Internationale, led by Dr. Idris. Trusted expertise, natural and lasting results."
  url="https://bangalore.hairclinique.in/hair-transplant-surgery-in-india.php"
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />

<div ref={pageRef} className="relative w-full bg-[#f2ece0] overflow-hidden mt-16 lg:mt-20" style={{ fontFamily: "'Raleway', sans-serif" }}>

  {/* ══════════════════════════════════════
      HERO
  ══════════════════════════════════════ */}
  <div className="relative h-[150px] xs:h-[280px] sm:h-[360px] md:h-[550px] flex items-center overflow-hidden">
    <img
      className="absolute inset-0 w-full h-full object-cover object-[center_20%]"
      src={HeroImg}
      alt="Hair Transplant Surgery in Bangalore"
    />
    <div className="absolute inset-0"    />
    <div
      className="absolute inset-0 opacity-40 pointer-events-none"
      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E\")" }}
    />
  </div>


        {/* BREADCRUMB */}
        <div className="bg-[#0e0905]/95 border-b border-[#c9a84c]/10">
          <div className={`${wrap} py-3 flex flex-wrap items-center gap-2`}>
            {PAGE.breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-[#c9a84c]/30 text-xs">›</span>}
                {b.href
                  ? <a href={b.href} style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]/60 hover:text-[#c9a84c] transition-colors">{b.label}</a>
                  : <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]">{b.label}</span>}
              </span>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 1 BIO text flows full width,
            wraps around a floated doctor image no blank space
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <EyebrowLeft>{PAGE.bio.eyebrow}</EyebrowLeft>
            <SectionHeading left>{PAGE.bio.heading}</SectionHeading>

            {/* doctor image floats right on desktop text wraps around it, then
                expands to full width once paragraphs run past its height
                so there is never a leftover empty gap. */}
            <div className="md:float-right md:w-[320px] md:ml-10 mb-8">
              <div className="relative overflow-hidden rounded-2xl border-2 border-[#c9a84c]/40">
                <img src={DrIdris} alt="Dr. Idris – Hair Transplant Surgeon" className="w-full object-cover object-top" style={{ maxHeight: "380px" }} />
                <div className="absolute bottom-3 left-3 bg-[#0e0905]/80 border border-[#c9a84c]/30 rounded-xl px-4 py-2.5 backdrop-blur-sm">
                  <p style={cinzel} className="text-[11px] font-bold tracking-[0.06em] text-white/90">Dr. Idris</p>
                  <p className="text-[10.5px] text-[#c9a84c]/80 mt-0.5">Director, Bangalore Division</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2 mt-4">
                {PAGE.bio.tags.map(t => (
                  <span key={t} style={cinzel} className="text-[9px] tracking-[0.1em] uppercase text-[#a07828] border border-[#c9a84c]/25 rounded px-2.5 py-1">{t}</span>
                ))}
              </div>
            </div>

            {/* paragraphs flow full-width, wrapping around the floated image */}
            {PAGE.bio.paragraphs.map((p, i) => (
              <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] mb-4">{p}</p>
            ))}
            <div className="clear-both" />
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 2 COST
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow>{PAGE.costSection.eyebrow}</Eyebrow>
              <SectionHeading>{PAGE.costSection.heading}</SectionHeading>
              {PAGE.costSection.paragraphs.map((p, i) => (
                <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-4">{p}</p>
              ))}

              {/* per-graft quick stats */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto mt-6 mb-10">
                {PAGE.costSection.perGraft.map((g) => (
                  <div key={g.label} className="bg-[#0e0905] border border-[#c9a84c]/20 rounded-2xl p-5 text-center relative overflow-hidden">
                    <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/50 to-transparent" />
                    <p style={cinzel} className="text-[11px] tracking-[0.08em] uppercase text-[#c9a84c]/80 mb-1.5">{g.label}</p>
                    <p style={cinzel} className="font-black text-[1rem] bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{g.range}</p>
                  </div>
                ))}
              </div>

              {/* baldness stage cost table */}
              <div className="overflow-x-auto rounded-2xl border border-[#c9a84c]/20 shadow-[0_4px_24px_rgba(90,60,10,0.07)] max-w-4xl mx-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-[#0e0905]">
                      {PAGE.costSection.tableHeads.map(h => (
                        <th key={h} style={cinzel} className="text-left text-[11px] tracking-[0.1em] uppercase text-[#c9a84c] px-5 py-4 font-bold whitespace-nowrap">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {PAGE.costSection.tableRows.map((r, i) => (
                      <tr key={i} className={`border-t border-[#c9a84c]/10 ${i % 2 === 0 ? "bg-white" : "bg-[#f2ece0]/60"} hover:bg-[#c9a84c]/[0.05] transition-colors`}>
                        <td className="px-5 py-4 text-[13px] font-bold text-[#a07828]">{r.stage}</td>
                        <td className="px-5 py-4 text-[13px] text-[#3a2e1e]">{r.grafts}</td>
                        <td className="px-5 py-4 text-[13px] font-semibold text-[#1a0f02]">{r.cost}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="text-center text-[13px] text-[#6b5535] mt-6 italic max-w-2xl mx-auto">{PAGE.costSection.note}</p>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SECTION 3 PROCEDURE STEPS dark band
        ══════════════════════════════════════ */}
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow light>How It Works</Eyebrow>
              <SectionHeading light>Procedure of Hair Transplant Surgery</SectionHeading>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                {PAGE.steps.map((s) => (
                  <div key={s.num} className="relative overflow-hidden bg-gradient-to-br from-[#c9a84c]/[0.07] to-[#c9a84c]/[0.02] border border-[#c9a84c]/15 rounded-2xl p-7 hover:border-[#c9a84c]/30 transition-colors">
                    <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/35 to-transparent" />
                    <span style={cinzel} className="font-black text-[2.2rem] leading-none text-[#c9a84c]/20 select-none block mb-3">{s.num}</span>
                    <div style={cinzel} className="text-[13px] font-bold tracking-[0.06em] uppercase text-white/90 mb-2.5">{s.title}</div>
                    <p className="text-[13px] leading-[1.8] text-white/55">{s.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 4 STAGES OF BALDNESS
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>Hair Loss Classification</Eyebrow>
            <SectionHeading>Stages of Baldness</SectionHeading>
            <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">
              The stages of male pattern baldness, often referred to as the Norwood scale, describe the progression of hair loss in men.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {PAGE.stages.map((s, i) => (
                <Card key={i} className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div style={{ background: `rgba(201,168,76,${0.08 + i * 0.03})`, borderColor: `rgba(201,168,76,${0.2 + i * 0.05})` }}
                      className="w-12 h-12 rounded-full border flex items-center justify-center flex-shrink-0">
                      <span style={cinzel} className="font-black text-[11px] text-[#c9a84c]">{s.stage.replace("Stage ", "S")}</span>
                    </div>
                    <div style={cinzel} className="text-[12.5px] font-bold uppercase tracking-[0.04em] text-[#1a0f02]">{s.label}</div>
                  </div>
                  <p className="text-[13px] leading-[1.75] text-[#6b5535]">{s.desc}</p>
                </Card>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 5 WHY CLINIQUE INTERNATIONALE
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow>Why Choose Us</Eyebrow>
              <SectionHeading>Why Clinique Internationale is Best for Hair Transplant Surgery in Bangalore?</SectionHeading>
              <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">{PAGE.whyClinique.intro}</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                {PAGE.whyClinique.reasons.map((w) => (
                  <Card key={w.num} className="p-6">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#c9a84c]/15 to-[#c9a84c]/[0.03] border border-[#c9a84c]/20 flex items-center justify-center mb-4">
                      <span style={cinzel} className="text-[11px] font-black text-[#c9a84c]">{w.num}</span>
                    </div>
                    <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.06em] uppercase text-[#1a0f02] mb-2.5">{w.title}</div>
                    <p className="text-[13px] leading-[1.75] text-[#6b5535]">{w.desc}</p>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            SECTION 6 TYPES OF HAIR TRANSPLANT SURGERY
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef}>
            <Eyebrow>Techniques</Eyebrow>
            <SectionHeading>What Are the Types of Hair Transplant Surgery?</SectionHeading>
            <div className="flex flex-col gap-6">
              {PAGE.types.map((t) => (
                <div key={t.num} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 sm:p-8 relative overflow-hidden hover:shadow-[0_8px_28px_rgba(90,60,10,0.08)] transition-shadow">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div className="flex gap-5 items-start flex-col sm:flex-row">
                    <span style={cinzel} className="font-black text-[2.4rem] leading-none text-[#c9a84c]/20 select-none flex-shrink-0">{t.num}</span>
                    <div className="flex-1">
                      {t.href
                        ? <a href={t.href} style={cinzel} className="text-[14px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] mb-3 hover:text-[#a07828] transition-colors inline-block">{t.title}</a>
                        : <div style={cinzel} className="text-[14px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] mb-3">{t.title}</div>}
                      <p className="text-[13.5px] leading-[1.85] text-[#6b5535]">{t.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            SECTION 7 TREATMENTS OFFERED dark band
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow light>Our Services</Eyebrow>
              <SectionHeading light>Hair Transplant Surgery Treatments We Offer</SectionHeading>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                {PAGE.treatments.map((t) => {
                  const inner = (
                    <>
                      <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/35 to-transparent" />
                      <div className="flex items-center gap-3 mb-3">
                        <span style={cinzel} className="font-black text-[1.4rem] leading-none text-[#c9a84c]/25 select-none">{t.num}</span>
                        <div style={cinzel} className="text-[12.5px] font-bold tracking-[0.05em] uppercase text-white/85 group-hover:text-[#ffe9a0] transition-colors">{t.title}</div>
                      </div>
                      <p className="text-[13px] leading-[1.75] text-white/50">{t.desc}</p>
                      {t.href && (
                        <div className="mt-3 flex items-center gap-1.5">
                          <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]/60 font-bold">Learn More</span>
                          <span className="text-[#c9a84c]/60 text-xs">→</span>
                        </div>
                      )}
                    </>
                  );
                  const cls = "relative overflow-hidden bg-gradient-to-br from-[#c9a84c]/[0.07] to-[#c9a84c]/[0.02] border border-[#c9a84c]/15 rounded-2xl p-6 hover:border-[#c9a84c]/30 hover:bg-[#c9a84c]/[0.1] transition-all duration-300 group block";
                  return t.href
                    ? <a key={t.num} href={t.href} className={cls}>{inner}</a>
                    : <div key={t.num} className={cls}>{inner}</div>;
                })}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            FAQs
        ══════════════════════════════════════ */}
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addRef}>
              <Eyebrow>Common Questions</Eyebrow>
              <SectionHeading>Frequently Asked Questions</SectionHeading>
              <div className="max-w-3xl mx-auto flex flex-col gap-3">
                {PAGE.faqs.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} />)}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* MISSION STRIP */}
        <div className="bg-[#0e0905] py-14 sm:py-16">
          <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
            <p style={cinzel} className="text-[1rem] sm:text-[1.2rem] md:text-[1.35rem] font-light leading-[1.7] text-white/85 tracking-[0.02em]">
              "Excellence in hair transplant surgery is not just a promise it is a standard we uphold with every single{" "}
              <em className="italic" style={{ color: "#c9a84c" }}>graft we place</em>."
            </p>
            <p className="text-[11px] tracking-[0.18em] uppercase text-[#c9a84c]/50 mt-5">
              Dr. Idris, Director · Clinique Internationale, Bangalore
            </p>
          </div>
        </div>
        <GoldDivider />

        {/* CTA */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addRef} className="max-w-xl mx-auto text-center">
            <Eyebrow>{PAGE.cta.eyebrow}</Eyebrow>
            <h3 style={cinzel} className="font-black text-[1.3rem] sm:text-[1.65rem] md:text-[1.9rem] text-[#1a0f02] uppercase tracking-[0.06em] mb-3.5">{PAGE.cta.heading}</h3>
            <p className="text-[14px] text-[#6b5535] leading-[1.75] mb-8">{PAGE.cta.sub}</p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a href={PAGE.cta.primary.href}
                style={{ ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-md text-[#1a0f02] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] transition-all inline-block">
                {PAGE.cta.primary.label}
              </a>
              <a href={PAGE.cta.secondary.href}
                style={cinzel}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-[13px] rounded-md bg-transparent border border-[#1a0f02]/35 text-[#1a0f02] hover:-translate-y-0.5 hover:border-[#c9a84c] hover:text-[#a07828] transition-all inline-block">
                {PAGE.cta.secondary.label}
              </a>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}